import { useCallback, useEffect, useRef } from 'react'

export function useDebounce(callback: (params: any) => any, delay: number) {
  const saveCallback = useRef<Function>()
  const timer = useRef<number>()

  useEffect(() => {
    saveCallback.current = callback
  })

  return useCallback(
    (...params) => {
      window.clearTimeout(timer.current)
      timer.current = window.setTimeout(
        () => saveCallback.current && saveCallback.current(...params),
        delay,
      )
    },
    [delay],
  )
}
